import { useCallback } from 'react';
import {
  TBuilderSelection,
  TRenderChatPanelParams,
} from '../components/WorkflowEditor/types';
import { useWorkflow } from '../context/WorkflowContext';
import { resolveBuilderSelection } from '../helpers/builder-selection';

/** The same canvas state `renderChatPanel` receives, for a host that mounts its chat panel outside
 * `WorkflowEditorContent` instead of in its slot. Deliberately narrower than `useWorkflow`: a panel
 * has no business reaching the rest of the editor's state. Must be called inside
 * `WorkflowEditorShell`. */
export const useWorkflowCanvasBinding = (): TRenderChatPanelParams => {
  const {
    workflow,
    applyRemoteWorkflow,
    hasUnsavedChanges,
    markAsSaved,
    setIsReadOnly,
    selectedEntities,
  } = useWorkflow();

  const getSelection = useCallback(
    (): TBuilderSelection | null =>
      resolveBuilderSelection(selectedEntities, workflow),
    [selectedEntities, workflow]
  );

  return {
    workflow,
    applyRemoteWorkflow,
    hasUnsavedChanges,
    markAsSaved,
    setIsReadOnly,
    getSelection,
  };
};
